/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { brand, location } from '../../redux/app-selectors'
import ButtonLink from '../button-link'
import { eligibilityRequest, staleResults } from '../../redux/product-tables/product-table-actions'
import { Palette } from '../../utils/palette'

const USwitchEligibilityBanner = ({
  noEligibilityResults,
  eligibilityResults,
  brand,
  resultsPage,
  eligibilityChecker,
  ctaVariant,
}: any) => {
  const [hasEligibilityResults, setHasEligibility] = useState(false)

  useEffect(() => {
    async function check() {
      try {
        const eligibility = await eligibilityRequest(brand)
        const eligibilityInfo = await eligibility.json()
        const expired = staleResults(eligibilityInfo)

        const hasEligibilityResults =
          !expired &&
          (!eligibilityInfo.errors || eligibilityInfo.errors.length === 0) &&
          eligibilityInfo.results?.length > 0

        setHasEligibility(hasEligibilityResults)
      } catch (error) {
        setHasEligibility(false)
      }
    }

    check()
  })

  return (
    <Palette
      as='div'
      sx={{ backgroundColor: '#141414', padding: ['42px 24px', '64px 24px'] }}
      px={{ backgroundColor: 'backgroundColor' }}
    >
      <div
        sx={{
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: ['column', 'row'],
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          justifyContent: ['flex-start', 'center'],
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <Palette as='h3' sx={BannerHeading} px={{ color: 'headingColor' }}>
          Check your eligibility for credit cards
        </Palette>
        <ul sx={BannerList}>
          <li sx={BannerListItem}>
            <Palette
              as='span'
              sx={BannerListItemCircle}
              px={{
                backgroundColor: 'featureColor',
                borderColor: 'accentColor',
                color: 'featureTextColor',
              }}
            >
              1
            </Palette>
            <Palette as='span' sx={BannerListItemText} px={{ color: 'textColor' }}>
              Improve your chances of being accepted
            </Palette>
          </li>
          <li sx={BannerListItem}>
            <Palette
              as='span'
              sx={BannerListItemCircle}
              px={{
                backgroundColor: 'featureColor',
                borderColor: 'accentColor',
                color: 'featureTextColor',
              }}
            >
              2
            </Palette>
            <Palette as='span' sx={BannerListItemText} px={{ color: 'textColor' }}>
              It won&apos;t affect your credit score
            </Palette>
          </li>
          <li sx={BannerListItem}>
            <Palette
              as='span'
              sx={BannerListItemCircle}
              px={{
                backgroundColor: 'featureColor',
                borderColor: 'accentColor',
                color: 'featureTextColor',
              }}
            >
              3
            </Palette>
            <Palette as='span' sx={BannerListItemText} px={{ color: 'textColor' }}>
              It&apos;s quick, free and easy
            </Palette>
          </li>
        </ul>
        <div
          sx={{
            flexGrow: [0, 1],
            marginTop: [0, 16],
            paddingLeft: [0, 10],
          }}
        >
          <ButtonLink
            variant={ctaVariant || 'secondary'}
            text={hasEligibilityResults ? eligibilityResults.button : noEligibilityResults.button}
            href={hasEligibilityResults ? resultsPage : eligibilityChecker}
            link={'/'}
            sx={{ color: !ctaVariant && '#141414 !important' }}
          />
        </div>
      </div>
    </Palette>
  )
}

const BannerHeading = {
  marginTop: '0',
  marginBottom: ['0', '24px'],
  width: '100%',
  fontSize: ['1.2em', '1.5em'],
  fontWeight: 700,
  color: '#fff',
}

const BannerList = {
  boxSizing: 'border-box' as const,
  display: 'flex',
  width: ['auto', '60%'],
  padding: '0',
  margin: ['1em 0 3em', '1em 0 1em'],
  alignItems: 'flex-start',
  flexDirection: ['column' as const, 'row' as const],
  justifyContent: 'center',
}

const BannerListItem = {
  boxSizing: 'border-box' as const,
  display: 'flex',
  width: '100%',
  margin: ['15px 0 0', '0'],
  alignItems: 'center',
  justifyContent: 'flex-start',
}

const BannerListItemCircle = {
  boxSizing: 'border-box' as const,
  display: 'inline-block',
  width: '36px',
  height: '36px',
  minWidth: '36px',
  minHeight: '36px',
  marginRight: '10px',
  lineHeight: '30px',
  textAlign: 'center' as const,
  background: '#fff',
  border: '3px solid #fff',
  borderRadius: '50%',
  alignSelf: 'flex-start',
  fontWeight: 800,
  backgroundColor: '#141414',
  color: '#fff',
}

const BannerListItemText = {
  boxSizing: 'border-box' as const,
  padding: '5px 10px 0',
  color: '#fff',
  flexGrow: 1,
  alignSelf: 'flex-start',
}

export default connect((state: any) => {
  const productType = state.contentful?.productTable?.fields?.schema?.productType

  const eligibilityChecker = productType
    ? `/credit-cards/eligibility-checker/form?productType=${productType}`
    : '/credit-cards/eligibility-checker/form'

  return {
    brand: brand(state),
    resultsPage: `${location(state).pathname}results/`,
    eligibilityChecker,
  }
})(USwitchEligibilityBanner)
